import React from 'react';


const LoadingSpinner = ({size}: {size: number}) => {

    return <div className="lds-spinner" data-testid="lds-spinner" style={{height:`${size}px`, width: `${size}px`, margin: '8px auto'}}><div /><div /><div /><div /><div /><div /><div /><div /></div>
}

export default LoadingSpinner